// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__3HyPA","root":"styles_root__63VMs","important":"styles_important__NAm1A","overdue":"styles_overdue__dG6-D"};